import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import API, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, new_password: password });
      setSuccess(true);
      toast.success("Password reset successfully!");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  if (!token) return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0] flex items-center justify-center">
      <div className="text-center">
        <p className="text-lg font-medium mb-4">Invalid reset link</p>
        <Link to="/login" className="text-[#00FF41] text-sm">Go to Login</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-2" data-testid="reset-title">Set New Password</h1>
        <p className="text-sm text-slate-500 mb-8">Enter your new password below.</p>

        {success ? (
          <div className="p-4 bg-[#00FF41]/10 border border-[#00FF41]/30 text-sm text-[#00FF41]" data-testid="reset-success">
            Password reset successfully! Redirecting to login...
          </div>
        ) : (
          <>
            {error && <div className="mb-4 p-3 bg-red-900/30 border border-red-800 text-sm text-red-400" data-testid="reset-error">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-form">
              <div>
                <label className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-1.5 block">New Password</label>
                <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
                  className="w-full bg-[#111111] border border-[#1E1E1E] px-4 py-3 text-sm text-[#F0F0F0] focus:outline-none focus:border-[#00FF41] transition-colors"
                  data-testid="reset-password-input" />
              </div>
              <div>
                <label className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500 mb-1.5 block">Confirm Password</label>
                <input type="password" required value={confirm} onChange={e => setConfirm(e.target.value)}
                  className="w-full bg-[#111111] border border-[#1E1E1E] px-4 py-3 text-sm text-[#F0F0F0] focus:outline-none focus:border-[#00FF41] transition-colors"
                  data-testid="reset-confirm-input" />
              </div>
              <button type="submit" disabled={loading}
                className="w-full bg-[#00FF41] text-[#0A0A0A] py-3 text-sm font-bold hover:bg-[#00CC33] transition-colors disabled:opacity-50"
                data-testid="reset-submit-button">
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
